query classRoomsCube($scenarioId: ID!, $filter: PaginationInput!, $originId: ID!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    classrooms(filter: $filter) {
      items {
        id
        code
        name
        usable
        capacity
        floor
        classroomType {
          code
          __typename
        }
        building {
          code
          name
          __typename
          campus {
            code
            __typename
          }
        }
        __typename
      }
      pageInfo {
        size
        page
        total
        hasNextPage
        hasPreviousPage
        __typename
      }
      __typename
    }
    __typename
  }
}
